import "./style.css";
import React from "react";
import { TopMenu } from "../../components/topmenu/TopMenu";
import { PlanetText } from "../../components/richtext/PlanetText";
import { SkySatText } from "../../components/richtext/SkySatText";
import { RadarSatText } from "../../components/richtext/RadarSatText";
import { AISText } from "../../components/richtext/AISText";
import qs from "querystring";

export class DataList extends React.Component {
  constructor(props) {
    super(props);
    this.state = { sel: "RADARSAT" };
  }

  componentDidMount() {
    let { search } = this.props.location;
    let result = qs.parse(search.slice(1));
    if (result.sel) {
      let { sel } = result;
      this.setState({
        sel,
      });
    }
  }

  componentWillUnmount() {
    this.setState({
      sel: "RADARSAT",
    });
  }

  render() {
    return (
      <div className="datal_div">
        <div className="news_list_div">
          <div className="data_category">
            <div className="about_category_items">
            
              <div
                className={
                  this.state.sel == "RADARSAT"
                    ? "category_item category_item_active"
                    : "category_item"
                }
                onClick={() => {
                  this.setState({ sel: "RADARSAT" });
                }}
              >
                <span className="category_link">RADARSAT-2</span>
              </div>
              <div
                className={
                  this.state.sel == "AIS"
                    ? "category_item category_item_active"
                    : "category_item"
                }
                onClick={() => {
                  this.setState({ sel: "AIS" });
                }}
              >
                <span className="category_link">AIS船舶监测</span>
              </div>
            </div>
          </div>
          <div
            id="about_content_id"
            className="news_list_content"
            data-animation="once"
            loaded="true"
            min-height="417"
            animated="true"
          >
            <div
              id="RADARSAT"
              className={
                this.state.sel === "RADARSAT" ? "p_about_content" : "hide_div"
              }
            >
              <article className="p_data_txt">
                <div className="reset_style">
                  <RadarSatText className="about_txt_2" />
                </div>
              </article>
            </div>

            <div
              id="AIS"
              className={
                this.state.sel === "AIS" ? "p_about_content" : "hide_div"
              }
            >
              <article className="p_data_txt">
                <div className="reset_style">
                  <AISText className="about_txt_2" />
                </div>
              </article>
            </div>
          </div>
        </div>
        <TopMenu />
      </div>
    );
  }
}
